/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Happy_Bat_GripInputs */

const en_thin_happy_bat_grip = /** @type {(inputs: Thin_Happy_Bat_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employee-Id`)
};

const de_thin_happy_bat_grip = /** @type {(inputs: Thin_Happy_Bat_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalnummer`)
};

/**
* | output |
* | --- |
* | "Employee-Id" |
*
* @param {Thin_Happy_Bat_GripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_happy_bat_grip = /** @type {((inputs?: Thin_Happy_Bat_GripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Happy_Bat_GripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_happy_bat_grip(inputs)
	return de_thin_happy_bat_grip(inputs)
});